// Which exported document's grid IS the building grid (root-04's route).
//
// The viewer asks at model-load time, before anyone presses G. It must
// not answer this question itself: the rule counts Copy/Monitor
// coincidence and label agreement with the building grid, and a second
// copy of it in the frontend is how the two drift. See
// back/utils/glance/gridFit.js gridSource.
import { url, tokenRef } from "api";

const auth = () => {
  const t = localStorage.getItem(tokenRef);
  return t ? { Authorization: `Bearer ${t}` } : {};
};

/**
 * -> { docName, how, lines, runnerUp, documents, exportVersion }
 *
 * `docName` is null with how 'no-grids' when the export carries none -
 * an explicit answer, not a 404 the viewer would have to interpret.
 *
 * ANY FAILURE RESOLVES TO null RATHER THAN THROWING. The grid is a
 * convenience on a button; a project whose grid source cannot be
 * resolved must still open its model. The caller treats null as "cannot
 * tell", which is already a state it handles honestly - it shows the
 * reference grid and says why.
 */
export const getGridSource = async (projectId, { lines = false } = {}) => {
  try {
    const res = await fetch(`${url}/projects/${projectId}/glance/grid-source${lines ? "?lines=1" : ""}`, { headers: auth() });
    if (!res.ok) return null;
    return await res.json();
  } catch (e) {
    return null;
  }
};
